'use client';

import RegistrationPage from '@/src/components/RegistrationPage';

export default function RegisterPage() {
  return <RegistrationPage />;
}
